<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Device Details</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-tablet"></i>
                    <span>Device Details </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container heightcls">
    <div class="well" style="height: 100%;">
        <device-list></device-list>
    </div>
</div>